import(/* webpackMode: "eager", webpackExports: ["BlogDetailPanel"] */ "/workspace/src/components/public/blog-panels.tsx");
